/** What the player's locomotion is doing (for the e2e hook `__uzNav.loco()` and the HUD). */
export interface LocoStatus {
  x: number;
  y: number;
  z: number;
  /** Body yaw and camera yaw (0 faces -Z). */
  facing: number;
  camYaw: number;
  /** Horizontal speed (m/s) and the body-frame velocity. */
  speed: number;
  right: number;
  fwd: number;
  onGround: boolean;
  gait: string;
  /** The animation graph's state: move, air, land, turn, action. */
  mode: string;
  aim: boolean;
  firstPerson: boolean;
  /** The camera arm length (third person). */
  arm: number;
  steps: number;
}

export const locoStatus: LocoStatus = {
  x: 0,
  y: 0,
  z: 0,
  facing: 0,
  camYaw: 0,
  speed: 0,
  right: 0,
  fwd: 0,
  onGround: true,
  gait: "idle",
  mode: "move",
  aim: false,
  firstPerson: false,
  arm: 0,
  steps: 0,
};
